/**
 * creates a map of "stack" action creators.
 * produces an object with same properties as a stackActionTypes object,
 * but with cooresponding action creator functions.
 *
 * @alias module:stack
 * @param {{}} [types] stackActionTypes object
 * @return {{}} map of "stack" action identifiers to action creators
 */
const stackActions = (types) => {
  const push = (value, meta) => ({
    type: types.push,
    payload: value,
    meta
  })

  const pop = (count, meta) => ({
    type: types.pop,
    payload: count,
    meta
  })

  const replace = (value, meta) => ({
    type: types.replace,
    payload: value,
    meta
  })

  const remove = (value, meta) => ({
    type: types.remove,
    payload: value,
    meta
  })

  const clear = (meta) => ({
    type: types.clear,
    meta
  })

  // TODO: support "batch" and/or "reduce" actions for stack reducer?

  return {
    push,
    pop,
    replace,
    remove,
    clear
  }
}

export default stackActions
